import { Component, Input } from '@angular/core';
import { Product } from 'src/app/models/core/product.model';
import { getSoldCount, getSoldPercentage } from 'src/app/utils/product-progress';

@Component({
  selector: 'app-product-progress-bar',
  templateUrl: './product-progress-bar.component.html',
  styleUrls: ['./product-progress-bar.component.scss'],
  standalone: false
})
export class ProductProgressBarComponent {
  @Input() product!: Product;
  @Input() totalProductsSoldType: 'percentage' | 'nominal' | 'hidden' | null = null;
  @Input() showVerified: boolean = false;
  @Input() isInsideCard: boolean = false;
  @Input() isDirectSale: boolean = false;

  get progressValue(): number {
    return getSoldCount(this.product);
  }

  get progressPercentage(): number {
    return getSoldPercentage(this.product);
  }

  get showProgress(): boolean {
    return this.totalProductsSoldType !== 'hidden';
  }

  get isComplete(): boolean {
    return this.progressPercentage >= 100;
  }
  
}
